module.exports = __webpack_public_path__ + "components/page-footer/static/snow-forecast__logo--white-f6a6a8fe6c3cb324ab2e8a4b0d55854b.png";